export const STANDARD_RATE_ADDITIONAL_TAX_CATEGORY_CODE = 'N';

const ZERO_TAX_AMOUNT_CATEGORIES = new Set(['E', 'O', 'Z', 'AE', 'N']);

export const isStandardRateAdditionalCategory = (code) => code === STANDARD_RATE_ADDITIONAL_TAX_CATEGORY_CODE;

export const calculatesZeroTaxAmount = (code) =>
  code != null && ZERO_TAX_AMOUNT_CATEGORIES.has(String(code).trim().toUpperCase());

export const effectiveTaxRateForCalculation = (categoryCode, percent) =>
  calculatesZeroTaxAmount(categoryCode) ? 0 : (percent ?? 0);
